import { gql } from "@apollo/client";

export const GET_ORDER_STATUS_V2 = gql`
  mutation getOrderDetailsByEmailV2(
    $email: String!
    $accountNumber: String
    $isNds: Boolean
    $usi: String
    $uuid: String
  ) {
    getOrderDetailsByEmailV2(
      email: $email
      accountNumber: $accountNumber
      isNds: $isNds
      usi: $usi
      uuid: $uuid
    ) {
      error
      APIStatus
      message
      orderDetails {
        orderId
        orderType
        installationAppointmentStartDate
        installationAppointmentEndDate
        isInstallationDay
        orderStatus
        technicianDetails {
          name
        }
        addressInfo {
          serviceAddress
          latitude
          longitude
        }
        dropshipInfo {
          shippingAddress
          trackingURL
          shippingDate
          model
          trackingDetails
        }
        showTechnicianTracker
        orderReschedule
        workOrderNumber
        checkMap
      }
    }
  }
`;

export const GET_TECHNICIAN_STATUS = gql`
  mutation getTechnicianStatus(
    $email: String!
    $accountNumber: String!
    $workOrderNumber: String!
  ) {
    getTechnicianStatus(
      email: $email
      accountNumber: $accountNumber
      workOrderNumber: $workOrderNumber
    ) {
      APIStatus
      error
      message
      longitude
      latitude
      orderStatus
      workOrderNumber
      estimatedTravelTime
      estimatedArrivalTime
    }
  }
`;

export const GET_ENV_VALUES = gql`
  query getEnvValuesFromFirestore($platform: String!) {
    getEnvValuesFromFirestore(platform: $platform) {
      envVariables {
        key
        value
      }
      paymentAmounts {
        key
        value
      }
      allBannerMessages {
        key
        title
        description
        linkText
        inLineMessage
      }
      routerCodes
      APIStatus
      error
      message
    }
  }
`;  

export const ACTION_TELEMETRY = gql`
  mutation late($payload: String!) {
    late(payload: $payload) {
      error
      APIStatus
      message
    }
  }
`;

export const CBST_KEY = gql`
  query cbstKey {
    cbstKey {
      cbstKey
      cbstKey2
      error
      APIStatus
      message
    }
  }
`;

export const CBST = gql`
  mutation cbst($payload: String!) {
    cbst(payload: $payload) {
      message
      APIStatus
      error
    }
  }
`;

export const VERIFY_TP_LINK = gql`
  query verifyTPLinkRouter($accountNumber: String!, $usi: String!, $isNds: Boolean!) {
    verifyTPLinkRouter(accountNumber: $accountNumber, usi: $usi, isNds: $isNds) {
      APIStatus
      error
      message
      tpLinkURL
      wifi7
      model
      tpLinkAndroid
      tpLinkApple
      tpLinkIntendIos
      tpLinkIntendAndroid
      showUpgradeRouter
    }
  }
`;

export const UPGRADE_BANNER_COPPER_CUSTOMERS = gql`
  mutation upgradeBannerForCopperCustomers($accountNumber: String!, $isNds: Boolean!) {
    upgradeBannerForCopperCustomers(accountNumber: $accountNumber, isNds: $isNds) {
      enableUpgradeBanner
      billingPage
      billingPageMessage
      message
      APIStatus
      error
    }
  }
`;

export const INACTIVE_ACCOUNT_BALANCE_BY_ACCOUNT_NUMBERS = gql`
  query inactiveAccountBalanceByAccountNumbers($accountNumbers: [String!]!) {
    inactiveAccountBalanceByAccountNumbers(accountNumbers: $accountNumbers) {
      dueBalanceDetails {
        accountNumber
        currentDueBalance
      }
      error
      message
      APIStatus
    }
  }
`;

export const DETERMINE_NETWORK_STATUS = gql`
  query determineNetworkStatus($accountNumber: String!, $usi: String!) {
    determineNetworkStatus(accountNumber: $accountNumber, usi: $usi) {
      error
      APIStatus
      message
      networkHealth
      speedTestEligible
      purchasedUploadSpeed
      purchasedDownloadSpeed
      customSpeedTestURL
      enableOwnRouterTest
    }
  }
`;
